import theme from '@globals/themes/defaultTheme'

/**
 * CSS styles for the RichTextEditorField (Froala editor wrapper).
 * Uses theme colors for placeholder, content, borders, and compact mode.
 */
export type RichTextEditorFieldStylesColors = {
  grayMedium: string
  grayPrimary: string
  grayExtraLight: string
}

export const getRichTextEditorFieldStyles = (colors: RichTextEditorFieldStylesColors): string => `
  .fr-placeholder {
    white-space: normal !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    overflow: visible !important;
    text-overflow: unset !important;
    font-size: 1rem !important;
    font-weight: normal !important;
    color: ${colors.grayMedium} !important;
    font-family: 'Figtree', sans-serif !important;
  }
  /* Match body1 typography for editor content */
  .fr-view,
  .fr-element {
    font-size: 1rem !important;
    font-weight: normal;
    color: ${colors.grayPrimary} !important;
    font-family: 'Figtree', sans-serif !important;
    line-height: 1.5 !important;
    display: block !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    max-width: 100% !important;
  }
  /* Prevent editor container from expanding with long unbroken text */
  .fr-box.fr-basic,
  .fr-box.fr-basic .fr-wrapper {
    max-width: 100% !important;
    min-width: 0 !important;
    z-index: auto !important;
  }
  .fr-box.fr-basic .fr-element {
    padding: 0 16px 24px 16px !important;
  }
  /* Compact mode: reduced padding */
  [data-rich-text-compact="true"] .fr-box.fr-basic .fr-element {
    padding: 0 16px 0 16px !important;
  }
  .fr-toolbar.fr-top {
    z-index: 0
  }
  /* Compact mode: round top corners only */
  [data-rich-text-compact="true"] .fr-box.fr-basic,
  [data-rich-text-compact="true"] .fr-box.fr-basic .fr-wrapper {
    border: 0.9px solid ${colors.grayExtraLight} !important;
    border-radius: 100px !important;
  }
  [data-rich-text-compact="true"] .fr-toolbar.fr-top {
    display: none !important;
  }
  [data-rich-text-compact="true"] .fr-second-toolbar {
    display: none !important;
  }
  /* Reserve horizontal space for the send button in comment form */
  .comment-form-editor .fr-second-toolbar .fr-counter { margin-right: 44px !important; }
  /* Compact mode: truncate text to 2 lines with ellipsis */
  [data-rich-text-compact="true"] .fr-element {
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }
  /* Compact mode: Add margin-bottom only when there is text content */
  [data-rich-text-compact-with-content="true"] .fr-element {
    margin-bottom: 16px !important;
  }
  .fr-popup .fr-icon-container {
    z-index: ${theme.zIndex.modal - 1} !important;
  }
  /* Default z-index for desktop popups */
  .fr-popup.fr-desktop {
    z-index: ${theme.zIndex.modal} !important;
  }
  /* Default z-index for mobile popups */
  .fr-popup.fr-mobile {
    z-index: ${theme.zIndex.modal} !important;
  }
   /* Left positioning for only emoticon popups */
  .fr-popup.fr-desktop:has(.fr-emoticon-container) {
    left: 180px !important;
  }
  /* Left positioning for mobile image tool popups */
  .fr-popup.fr-mobile:has(.fr-buttons) {
    left: auto !important;
    right: 0 !important;
  }
`
